import {ChangeEvent, useEffect, useMemo, useState} from 'react';
import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';

import {FlattenedProduct} from '../../utils/graphql';
import QuantityAdjustableBuyTicketWidget from './QuantityAdjustableBuyTicketWidget.client';

interface TwlEventBuyTicketWidgetProps {
  shopifyProduct: FlattenedProduct;
}

export function TwlEventBuyTicketWidget({
  shopifyProduct,
}: TwlEventBuyTicketWidgetProps) {
  const [selectedVariant, setSelectedVariant] = useState<ProductVariant>(null);

  const isSingleSessionEvent = useMemo(
    () => shopifyProduct && shopifyProduct.variants.length === 1,
    [shopifyProduct],
  );
  useEffect(() => {
    if (isSingleSessionEvent) {
      setSelectedVariant(shopifyProduct.variants[0]);
    }
  }, [isSingleSessionEvent, shopifyProduct]);

  return (
    <QuantityAdjustableBuyTicketWidget shopifyVariant={selectedVariant}>
      {!isSingleSessionEvent && (
        <div className="form__row mt-15">
          <select
            className="form__element"
            id="choose-time"
            placeholder="Choose Time"
            autoComplete="off"
            onChange={(e: ChangeEvent<HTMLSelectElement>) => {
              const variant = shopifyProduct.variants.find(
                (v) => v.id === e.target.value,
              );
              setSelectedVariant(variant);
            }}
          >
            <option value="" disabled selected>
              Choose Date &amp; Time
            </option>
            {shopifyProduct.variants.map(({id, title, availableForSale}) => (
              <option key={id} value={id} disabled={!availableForSale}>
                {availableForSale ? title : `* Sold Out * ${title}`}
              </option>
            ))}
          </select>
        </div>
      )}
    </QuantityAdjustableBuyTicketWidget>
  );
}

export function ExternalEventBuyTicketWidget({
  externalUrl,
}: {
  externalUrl: string;
}) {
  return (
    <>
      <a
        href={externalUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="buy-tickets__mobile"
        style={{color: '#ffffff'}}
        id="buyTicketsTrigger"
      >
        <span className="buy-tickets-text">
          Buy Tickets <i className="icon-tickets" />
        </span>
        <span className="buy-tickets-close-text"> Close </span>
      </a>
      <div className="buy-tickets" id="buy-tickets">
        <h6 className="buy-tickets__title title-1">Buy tickets</h6>
        <div className="buy-tickets__form">
          <div className="form__row mt-30">
            <a
              className="button button_full"
              href={externalUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Buy Tickets
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
